export default {"src":"https://cdn.tanzhi.cn/_next/static/media/market.ceafbd6f.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};